import ListProducts from "@mindarc/arctheme-components/frontend/src/stories/components/ecommerce/ListProducts/ListProducts";
import recentlyviewed from "../js/alpine/components/recentlyviewed";
import ExtendedRecommendedProducts from "../src/stories/components/RecommendedProducts/ExtendedRecommendedProducts";
import ExtendedListProducts from "../src/stories/components/ExtendedListProducts/ExtendedListProducts";
import ExtendedListBlogs from "../src/stories/components/ExtendedListBlogs/ExtendedListBlogs";
import ExtendedProductInclusionsList from "../src/stories/components/ExtendedRecipeProductInclusionsList/ExtendedRecipeProductInclusionsList";
import ExtendedRecipeRecommendationsList from "../src/stories/components/ExtendedRecipeRecommendationsList/ExtendedRecipeRecommendationsList";
import Wishlist from "@src/stories/sections/Wishlist/Wishlist";
import { useEffect, useState } from "react";
import shopify from "../js/shopify";
import { inflateShared } from "../js/globals";

const sampleProducts = [
  {
    product: {
      id: "1",
      title: "Product A",
      image: "https://via.placeholder.com/150",
      price: 99.99,
      url: "/",
    },
  },
  {
    product: {
      id: "2",
      title: "Product B",
      image: "https://via.placeholder.com/150",
      price: 149.99,
      url: "/",
    },
  },
  {
    product: {
      id: "3",
      title: "Product C",
      image: "https://via.placeholder.com/150",
      price: 199.99,
      url: "/",
    },
  },
];

export function RecommendedProductList({ ...props }) {
  const [products, setProducts] = useState([]);
  
  // Hydrate shared props to ensure globals and other shared data is available
  const hydratedSettings = inflateShared(props.settings);
  const { product } = hydratedSettings;



  useEffect(() => {
    async function fetchProductRecommendations(productId) {
      const recommendedProducts =
        await shopify.getRecommendedProducts(productId);
      setProducts(recommendedProducts);
    }

    if (product?.id) {
      fetchProductRecommendations(product.id);
    }
  }, [product]);

  const recentlyviewedproducts = recentlyviewed.component().get();

  if (products.length === 0 || recentlyviewedproducts.length === 0) {
    return null;
  }

  return (
    <ExtendedRecommendedProducts
      products={products}
      settings={hydratedSettings.section}
      wishlist={hydratedSettings.globals?.enable_wishlist}
      recentlyviewed_products={recentlyviewedproducts}
    />
  );
}

export function ProductsList({ ...props }) {
  let productData = sampleProducts;

  // Hydrate shared props to ensure globals and other shared data is available
  const hydratedSettings = inflateShared(props.settings);
  
  const type = hydratedSettings.section.type;
  console.log('Products', props);
  if (type == "products" && hydratedSettings.blocks.length > 0) {
    productData = hydratedSettings.blocks;
  } else if (hydratedSettings.collection.products.length > 0) {
    productData = hydratedSettings.collection.products;
  }

  return (
    <ExtendedListProducts
      products={productData}
      type={type}
      settings={hydratedSettings.section}
      wishlist={hydratedSettings.globals?.enable_wishlist}
      localization={hydratedSettings.localization}
      translations={hydratedSettings.translations}
      section_id={hydratedSettings.section_id}
      add_to_cart={hydratedSettings.routes?.add_to_cart_url}
    />
  );
}

export function BlogsList({ ...props }) {
  // Hydrate shared props to ensure globals and other shared data is available
  const hydratedSettings = inflateShared(props.settings);
  
  const type = hydratedSettings.section.type;
  const blocks = hydratedSettings.blocks;
  const blogArticles = hydratedSettings.blog;

  return (
    <ExtendedListBlogs
      blocks={blocks}
      blog={blogArticles}
      type={type}
      settings={hydratedSettings.section}
      translations={hydratedSettings.translations}
      section_id={hydratedSettings.section_id}
    />
  );
}

export function RecentlyViewedProductsList({ ...props }) {
  // console.log('Retrieiving Products from Recently Viewed Component');
  // Hydrate shared props to ensure globals and other shared data is available
  const hydratedSettings = inflateShared(props.settings);
  
  const products = recentlyviewed.component().get();

  if (products.length <= 0) {
    return false;
  }

  const productData = products.map((item) => ({
    ...item,
    featured_image: item.featuredImage?.src,
    images: item.media.map((mediaItem) => mediaItem.src),
    selected_or_first_available_variant: item.variants[0],
  }));

  return (
    <ExtendedListProducts
      products={productData}
      settings={hydratedSettings.section}
      translations={hydratedSettings.translations}
      localization={hydratedSettings.localization}
      section_id={hydratedSettings.section_id}
      add_to_cart={hydratedSettings.routes?.add_to_cart_url}
    />
  );
}

export function RecipeInclusionProductsList({ ...props }) {
  // Hydrate shared props to ensure globals and other shared data is available
  const hydratedSettings = inflateShared(props.settings);
  
  return (
    <ExtendedProductInclusionsList
      products={hydratedSettings.products}
      translations={hydratedSettings.translations}
      localization={hydratedSettings.localization}
      section_id={hydratedSettings.section_id}
      add_to_cart={hydratedSettings.routes?.add_to_cart_url}
    />
  );
}

export function RecipeRecommendationsList({ ...props }) {
  // Hydrate shared props to ensure globals and other shared data is available
  const hydratedSettings = inflateShared(props.settings);
  
  return (
    <ExtendedRecipeRecommendationsList
      recipes={hydratedSettings.recipes}
      translations={hydratedSettings.translations}
      localization={hydratedSettings.localization}
      section_settings={hydratedSettings}
      section_id={hydratedSettings.section_id}
      add_to_cart={hydratedSettings.routes?.add_to_cart_url}
      wishlist={hydratedSettings?.enable_wishlist}
    />
  );
}

export function RecipeSliderList({ ...props }) {
  // Hydrate shared props to ensure globals and other shared data is available
  const hydratedSettings = inflateShared(props.settings);
  
  const all_recipes = hydratedSettings.all_recipes;
  const recipeHandles = hydratedSettings.recipes;
  const matchingRecipes = all_recipes.filter((recipe) =>
    recipeHandles.some((handle) => recipe.url === handle.handle),
  );
  return (
    <ExtendedRecipeRecommendationsList
      type="categories"
      recipes={matchingRecipes}
      translations={hydratedSettings.translations}
      localization={hydratedSettings.localization}
      section_settings={hydratedSettings}
      section_id={hydratedSettings.section_id}
      add_to_cart={hydratedSettings.routes?.add_to_cart_url}
      wishlist={hydratedSettings?.enable_wishlist}
    />
  );
}

export function WishlistComponent({ ...props }) {
  // Hydrate shared props to ensure globals and other shared data is available
  const hydratedSettings = inflateShared(props.settings);
  
  return <Wishlist settings={hydratedSettings} />;
}
